export const EYE_TRACKING_ERRORS = {
    NotSupported: 'Chrome extensions is not supported',
};
